// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "Lions Higher primary school",
    contact: "+91 6360254059,+91 9845825589 | lionssklmbl@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/lionshps?utm_source=qr&igsh=eTg1N3BvZWZ3OWQ%3D",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/watch?v=kALbYDV_ql8",
      facebook:   "https://www.facebook.com/lions.hps.muddebihal",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
